import React from 'react';

import PromoSpinner from 'apps/promo/components/common/promo-spinner/PromoSpinner';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';

const WhiteScreenMobileAppPage = () => {
    return <PromoSpinner forceShow={true} isEmptyText />;
};

export default BasePageForNoAuth(WhiteScreenMobileAppPage);
